export default {"src":"/_next/static/media/money.81a82f75.svg","height":40,"width":41,"blurWidth":0,"blurHeight":0};